import React, { useState } from 'react';
import { AppBar, Toolbar, Typography, Box, IconButton, Drawer, List, ListItem } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';

import {
    NavLink
} from "react-router-dom";
import '../../SbtierCSS/Header.css';

const navLinkClass = ({ isActive }) => `sbtier-nav-link${isActive ? " active" : ""}`;
const mobileNavLinkClass = ({ isActive }) => `sbtier-mobile-nav-link${isActive ? " active" : ""}`;

const navItems = [
    { to: "/", label: "HOME", end: true },
    { to: "/Sbtier-AboutUs", label: "ABOUT US" },
    { to: "/Sbtier-Services", label: "SERVICES" },
    { to: "/Sbtier-Career", label: "CAREER" },
    { to: "/contact-us", label: "CONTACT US" },
];

function SbtierHeader(){
    const [menuOpen, setMenuOpen] = useState(false);

    return(
        <AppBar position="static" className="sbtier-appbar" elevation={0}>
            <Toolbar className="sbtier-toolbar">
                {/* Logo Section */}
                <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
                    <img src="/images/company_logo.png" alt="company Logo" style={{
              height: "42px",
              width: "auto",
              marginRight: "14px",
            }}/>
            <Typography
            variant="h6"
            component="div"
            className="sbtier-brand"
            sx={{ display: { xs: "none", sm: "block" } }}
          >
            SatyaBalTech Semiconductor
          </Typography>
                </Box>

                {/* Desktop Navigation */}
                <Box className="sbtier-nav" sx={{ display: { xs: "none", md: "flex" } }}>
                    {navItems.map((item) => (
                        <NavLink key={item.to} to={item.to} end={item.end} className={navLinkClass}>
                            {item.label}
                        </NavLink>
                    ))}
                </Box>

                {/* Mobile menu toggle */}
                <IconButton
                    className="sbtier-menu-toggle"
                    aria-label="Open navigation menu"
                    onClick={() => setMenuOpen(true)}
                    sx={{ display: { xs: "inline-flex", md: "none" } }}
                >
                    <MenuIcon />
                </IconButton>
            </Toolbar>

            <Drawer
                anchor="right"
                open={menuOpen}
                onClose={() => setMenuOpen(false)}
                className="sbtier-drawer"
                PaperProps={{ className: "sbtier-drawer-paper" }}
            >
                <div className="sbtier-drawer-header">
                    <IconButton aria-label="Close navigation menu" onClick={() => setMenuOpen(false)}>
                        <CloseIcon sx={{ color: "var(--header-ink)" }} />
                    </IconButton>
                </div>
                <List>
                    {navItems.map((item) => (
                        <ListItem key={item.to} disablePadding>
                            <NavLink
                                to={item.to}
                                end={item.end}
                                className={mobileNavLinkClass}
                                onClick={() => setMenuOpen(false)}
                            >
                                {item.label}
                            </NavLink>
                        </ListItem>
                    ))}
                </List>
            </Drawer>
        </AppBar>
    );
}

export default SbtierHeader;
